import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as appDataActions from '../../../../actions/appDataActions';
import Button from "../../../buttons/Button";
import Resources from '../../resourceLinks/ResourceLinks';
import Image from '../../../objects/image/SecondaryImage';
import LibraryImage from '../../../objects/image/SecondaryLibraryImage';
import KpiDashboard from "../../kpi/KpiDashboard";
import OptionFeedback from "../OptionFeedback";
import ScoreKpi from '../../kpi/ScoreKpi';//eslint-disable-line import/no-named-as-default
import Conversation from '../../conversationDialog/ChildConversationDialog';
import BadgeCollect from '../../badges/BadgeCollect';
import * as trackingDataActions from "../../../../actions/trackingDataActions";
import * as userDataActions from "../../../../actions/userDataActions";
import * as appHelper from "../../../../helpers/appHelper";
import * as dataHelper from "../../../../helpers/dataHelper";
import * as appConstants from "../../../../constants/appConstants";
import * as objectConstants from "../../../../constants/objectConstants";
import * as kpiConstants from "../../../../constants/kpiConstants";
import * as assetConstants from '../../../../constants/assetConstants';
import * as keyboardConstants from '../../../../constants/keyboardConstants';

import * as localStorage from "../../../../localStorage/localStorage";
import {TweenLite, Elastic, Bounce, Expo, Linear} from "gsap";//eslint-disable-line import/no-named-as-default
//eslint-disable-line import/no-named-as-default
//eslint-disable-line import/no-named-as-default


class SingleAnswerFeedback extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            option: this.props.option,
            options: this.props.options,
            locale: appHelper.getLocalData(this.props.option),
            hideFeedback: this.props.hideFeedback,
            showKpis: this.props.screenObject.scoring_type === objectConstants.SCORING_TYPE_ASSESSED && appHelper.isDefined(this.props.option.kpis) && this.props.option.kpis !== null,
            showProgression: false,
            enableProgression: this.props.screenObject.scoring_type !== objectConstants.SCORING_TYPE_ASSESSED || this.props.option.kpis === null,
            optionFeedback: [],
            kpiDashboardParams: {
                showTitle: false,
                showImmediateImpact: true,
                allowUpdates: false
            },
            hasDialogs: appHelper.isDefined(this.props.option.dialogs) && this.props.option.dialogs.length > 0,
            dialogComplete: !appHelper.isDefined(this.props.option.dialogs) || this.props.option.dialogs.length === 0,
            hasBadges: appHelper.isDefined(this.props.option.badges) && this.props.option.badges.length > 0,
            badgesCollected: false,
            resourceLinks: [],
            hasResources: false,
            resourcesAreComplete: true,
            optionAsset: {
                src: ""
            },
            assetData: {},
            completionCalled: false,
            feedbackInterval: {},
            review_other_options_label: appHelper.getLocaleString("review_other_options_label"),
        };
        this.show = this.show.bind(this);
        this.onFeedbackRevealed = this.onFeedbackRevealed.bind(this);
        this.onFeedbackHidden = this.onFeedbackHidden.bind(this);
        this.onProgressionClicked = this.onProgressionClicked.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.handleOptionFeedback = this.handleOptionFeedback.bind(this);
        this.storeUserResponse = this.storeUserResponse.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.getLinkClass = this.getLinkClass.bind(this);
        this.getDisabledState = this.getDisabledState.bind(this);
        this.dialogsOnComplete = this.dialogsOnComplete.bind(this);
        this.onBadgeCollected = this.onBadgeCollected.bind(this);
        this.onResourcesComplete = this.onResourcesComplete.bind(this);
        this.setResources = this.setResources.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getAssetType = this.getAssetType.bind(this);
        this.getInheritedFeedback = this.getInheritedFeedback.bind(this);
        this.checkIsReadyToComplete = this.checkIsReadyToComplete.bind(this);
        this.setComplete = this.setComplete.bind(this);
        this.showProgressButton = this.showProgressButton.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.onReview = this.onReview.bind(this);
        this.setFeedbackInterval = this.setFeedbackInterval.bind(this);
        this.checkShowProgressButton = this.checkShowProgressButton.bind(this);
    }

    componentDidMount() {

        this.getAssets();
        //this.handleOptionFeedback();
        this.setResources();
        this.show();
        this.setFeedbackInterval();
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.option.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.option.character_pose);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.hideFeedback !== nextProps.hideFeedback) {
            this.setState({hideFeedback: nextProps.hideFeedback});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.option),
                review_other_options_label: appHelper.getLocaleString("review_other_options_label"),
            });
        }
    }

    componentDidUpdate() {
        if (this.checkIsReadyToComplete()) {
            this.setComplete();
        }
        if (this.state.hideFeedback) {
            this.hide();
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.feedbackInterval);
    }

    setFeedbackInterval() {
        let interval = setInterval(this.checkShowProgressButton, 500);
        this.setState({feedbackInterval: interval});
    }

    checkShowProgressButton() {
        if (this.showProgressButton()) {
            this.props.onEnableProgression(this.state.locale.progression_label);
            clearInterval(this.state.feedbackInterval);
        }
    }

    getAssets() {
        let screenAsset = {};
        let assetData = {};

        if (appHelper.isDefined(this.state.option.image)) {
            screenAsset = this.getAssetType(this.state.option.image);
            assetData = Object.assign({}, this.state.option.image);
        }

        this.setState({
            screenAsset: Object.assign({}, screenAsset),
            assetData: Object.assign({}, assetData)
        });

        if (appHelper.isDefined(this.state.option.audio)) {
            let audio = appHelper.getAudioAsset(this.state.option.audio);
            let audioObj = {
                audioRef: `audio_${audio.id}_${audio.type}`
            };

            this.props.actions.setAudio(audioObj);
        }
    }

    getAssetType(asset) {
        /*
         screenCharacter = appHelper.getCharacterAsset(this.state.screen.assets.left);
            //console.log(screenCharacter);
            characterAsset = appHelper.getCharacterPose(screenCharacter, this.state.screen.assets.left);
        * */
        let returnAsset = {};
        if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
            returnAsset = appHelper.getIconAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
            returnAsset = appHelper.getImageAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
            returnAsset = appHelper.getLibraryImageAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER) {
            let characterAsset = appHelper.getCharacterAsset(asset);
            returnAsset = appHelper.getCharacterPose(characterAsset, asset);
        }
        returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;

        if(appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)){
            returnAsset = Object.assign({},returnAsset,{
                type: asset.constant
            });
        }

        return returnAsset;
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    storeUserResponse() {
        let selectedOptions = [this.state.option.option_id];
        let responseObj = {
            asset_id: this.props.asset_id,
            selectedOptions: selectedOptions,
            kpis: this.state.option.kpis !== null ? this.state.option.kpis : []
        };
        this.props.callbacks.storeUserResponse(responseObj);
    }


    scrollToTop() {
        let feedback = document.getElementById(`feedback_wrapper_${this.props.asset_id}`);
        this.props.callbacks.scrollToFeedback(feedback.offsetTop);
    }

    enableProgression() {
        this.setState({enableProgression: true});
    }

    getLinkClass() {
        return this.state.enableProgression ? "" : "disabled-link";
    }

    getDisabledState() {
        return !this.state.enableProgression;
    }

    handleOptionFeedback() {
        let feedbackOptions = [];
        let noMsgObj = {
            id: "none",
            feedback: "",
            options: [],
            checked: false,
        };

        let optionsForFeedback = [];
        for (let i = 0; i < this.props.options.length; i++) {
            let option = this.props.options[i];
            let locale = appHelper.getLocalData(option);

            let isChecked = this.state.option.option_id === option.option_id;
            let optionObject = {
                result: option.result,
                className: isChecked ? 'checked' : 'unchecked',
                option_text: locale.option,
                option_id: option.option_id,
                kpis: appHelper.isDefined(option.kpis) && option.kpis !== null ? option.kpis : []
            };

            if (isChecked) {
                optionsForFeedback = dataHelper.immutablePush(optionsForFeedback, optionObject);
            }

        }

        if (optionsForFeedback.length > 1) {

            optionsForFeedback.sort(function (a, b) {
                if (a.className < b.className) return -1;
                if (a.className > b.className) return 1;
                return 0;
            });
        }

        if (optionsForFeedback.length > 0) {
            noMsgObj = Object.assign({}, noMsgObj,
                {
                    options: Object.assign([], optionsForFeedback)
                }
            );
        }

        if (noMsgObj.options.length > 0) {
            feedbackOptions = dataHelper.immutablePush(feedbackOptions, noMsgObj);
        }


        this.setState({optionFeedback: Object.assign([], feedbackOptions)});
    }

    onFeedbackRevealed() {
        this.storeUserResponse();
        this.scrollToTop();
    }

    onFeedbackHidden() {
      //  this.props.callbacks.resizeWatcher();
        if (typeof this.props.onComplete !== 'undefined') {
            this.props.onComplete();
        }
    }

    showFeedbackContent() {
        this.setState({showFeedbackContent: true});
    }

    onProgressionClicked() {
        this.hide();
    }

    show() {
        let feedbackPanel = this.refs[`${this.state.option.option_id}_feedbackPanel`];
        TweenLite.set(feedbackPanel, {height: "auto", opacity: 1});
        TweenLite.from(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
            height: 0,
            opacity: 0,
            ease: Expo.easeInOut
        }).eventCallback("onComplete", this.onFeedbackRevealed);
        /**/
    }

    hide() {
        this.setState({hideFeedback: false});
        let feedbackPanel = this.refs[`${this.state.option.option_id}_feedbackPanel`];
        TweenLite.to(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
            height: 0,
            opacity: 0,
            ease: Expo.easeInOut,
        }).eventCallback("onComplete", this.onFeedbackHidden);
    }


    onToolboxComplete(progression, asset_id, latestResponse) {
        this.setState({toolboxIsComplete: true});
    }

    setToolboxCallbacks() {
        this.setState(
            {
                toolboxCallbacks: Object.assign({}, this.state.toolboxCallbacks,
                    {
                        onObjectComplete: this.onToolboxComplete,
                        isReviewMode: function () {
                            return false;
                        }
                    }
                )
            }
        );
    }

    onBadgeCollected() {
        this.setState({badgesCollected: true});
        //this.hide();
    }

    dialogsOnComplete() {
        this.setState({dialogComplete: true});
    }

    setResources() {
        let resourceLinks = appHelper.setResourceLinks(this.state.option);

        this.setState({
            resourceLinks: Object.assign([], resourceLinks),
            hasResources: resourceLinks.length > 0,
            resourcesAreComplete: resourceLinks.length === 0
        });

    }

    onResourcesComplete() {
        if (!this.state.resourcesAreComplete) {
            this.setState({resourcesAreComplete: true, checkComplete: true});
        }
    }

    getInheritedFeedback(feedback_id) {
        let option = appHelper.getArrayObjectByKey(this.state.options, "option_id", feedback_id);
        let optionLocale = appHelper.getLocalData(option);
        return optionLocale.feedback;
    }

    checkIsReadyToComplete() {
        return !this.props.callbacks.hasNextObject(this.props.index)
            && this.state.option.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN
            && this.state.enableProgression
            && !this.state.completionCalled
            //&& ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
            && this.state.resourcesAreComplete;
    }

    setComplete() {
        this.setState({completionCalled: true});
        this.props.onComplete();
    }

    showProgressButton() {
        /*return (
            (!this.props.callbacks.hasNextObject(this.props.screenObject) && this.state.option.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) || this.props.callbacks.hasNextObject(this.props.screenObject))
            && appHelper.isDefined(this.state.locale.progression_label)
            && ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
            && this.state.resourcesAreComplete;*/
        return this.state.enableProgression
            && appHelper.isDefined(this.state.locale.progression_label)
            //&& ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
            && this.state.resourcesAreComplete;
    }

    setKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            if (this.state.enableProgression) {
                this.onReview();
            }
        }
    }

    onReview() {
        if (this.state.enableProgression) {
            this.props.onShowReview(`review_link_${this.state.option.option_id}`);
        }
    }

    render() {
        return (

            <div className={`feedback-panel ${this.state.option.result}`}
                 ref={`${this.state.option.option_id}_feedbackPanel`}
                 id={`${this.state.option.option_id}_feedbackPanel`}>
                <img src={require(`../../../../assets/images/svg/${this.state.option.result}.svg`)} style={kpiConstants.WATERMARK_STYLES} alt=""/>
                <div className="feedback-content-col">

                    {this.state.showKpis
                        ? <ScoreKpi bite_id={this.props.responseData.bite_id}
                                    displayState={kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL}
                                    showImmediateImpact={this.state.kpiDashboardParams.showImmediateImpact}
                                    showTitle={this.state.kpiDashboardParams.showTitle}
                                    onUpdateComplete={this.enableProgression}/>
                        : null
                    }

                    {this.state.optionFeedback.length > 0 && this.props.option.enable_feedback
                        ? <OptionFeedback feedback_options={this.state.optionFeedback}
                                          asset_id={this.props.asset_id}
                                          responseData={this.props.responseData}
                        />
                        : null
                    }

                    {
                        appHelper.isDefined(this.state.assetData.constant) && (!appHelper.isDefined(this.props.showImages) || (appHelper.isDefined(this.props.showImages) && this.props.showImages))
                            ?

                            <div className="feedback-image">
                                <div className="image-container">
                                    {this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE || this.state.assetData.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE
                                        ?
                                        this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE
                                            ?
                                            <Image screenObject={this.state.assetData}/>
                                            :
                                            <LibraryImage screenObject={this.state.assetData}/>
                                        :
                                        <img src={this.getImagePath(this.state.screenAsset.src)} alt=""/>
                                    }
                                </div>
                            </div>
                            :
                            null
                    }

                    {appHelper.isDefined(this.state.locale.feedback) && this.state.locale.feedback.length > 0 && this.state.locale.feedback !== "<p><br></p>" && this.props.option.enable_feedback
                        ? <div dangerouslySetInnerHTML={{__html: this.state.locale.feedback}}/>
                        :
                        appHelper.isDefined(this.state.option.feedback_id)
                            ?
                            <div
                                dangerouslySetInnerHTML={{__html: this.getInheritedFeedback(this.state.option.feedback_id)}}/>
                            :
                            null
                    }

                    {
                        this.state.hasResources
                            ?
                            <Resources resources={this.state.resourceLinks}
                                       onResourcesComplete={this.onResourcesComplete}/>
                            :
                            null
                    }
                    


                    {this.props.option.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && this.state.resourcesAreComplete && this.props.contentData.experience.include_explore_feedback
                        ?
                        <div className={`guroo-active-link text-center ${this.getLinkClass()}`} role="link"
                             tabIndex="0"
                             id={`review_link_${this.state.option.option_id}`}
                             onKeyDown={this.setKeyboardAccessibility}
                             onClick={this.onReview}>{this.state.review_other_options_label}</div>
                        : null
                    }

                </div>
            </div>


        );
    }
}

SingleAnswerFeedback.propTypes = {
    screenObject: PropTypes.object,
    option: PropTypes.object.isRequired,
    options: PropTypes.array.isRequired,
    responseData: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    asset_id: PropTypes.number.isRequired,
    index: PropTypes.number,
    onComplete: PropTypes.func,
    onShowReview: PropTypes.func,
    scrollToFeedback: PropTypes.func,
    actions: PropTypes.object,
    contentData: PropTypes.object.isRequired,
    showImages: PropTypes.bool,
    onEnableProgression: PropTypes.func,
    lang: PropTypes.string.isRequired,
    hideFeedback: PropTypes.bool,
};

SingleAnswerFeedback.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SingleAnswerFeedback);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/singleAnswer/SingleAnswerFeedback.js
 **/